import commonConfig from './common/common.config'
import objectConfig from './object/object.config'
import sidebarConfig from './sidebar/sidebar.config'

export class ReportConfig {
  static readonly common = commonConfig
  static readonly object = objectConfig
  static readonly sidebar = sidebarConfig
}
